import { Button } from "@/components/ui/button"

interface FormActionsProps {
  isPending: boolean
  onBack?: () => void
  onSubmit: () => void
  submitLabel?: string
  showDraft?: boolean
}

export function FormActions({
  isPending,
  onBack,
  onSubmit,
  submitLabel = "Salvar & Continuar",
  showDraft = true,
}: FormActionsProps) {
  return (
    <div className="flex justify-end gap-4">
      {showDraft && (
        <Button
          type="button"
          variant="outline"
          size="sm"
          disabled={isPending}
          onClick={onBack}
          className="px-8"
        >
          Voltar
        </Button>
      )}

      <Button
        type="button"
        size="sm"
        disabled={isPending}
        isLoading={isPending}
        onClick={onSubmit}
        className="px-8"
      >
        {submitLabel}
      </Button>
    </div>
  )
}
